import React from 'react';
import { messages } from 'constants/messages';
import PropTypes from 'prop-types';

export default function noData(props) {
  return (
    <div className={`content-notfound ${props.className}`}>
      <div className="center-block">
        <img alt={messages.KHONG_CO_DU_LIEU} className="bg-notdata" src={`${process.env.PUBLIC_URL}/search.png`} />
        <h3 className="heading">{messages.KHONG_CO_DU_LIEU}</h3>
      </div>
    </div>
  );
}

noData.propTypes = {
  className: PropTypes.string
};

noData.defaultProps = {
  className: ''
};

noData.displayName = 'NoData';
